import { getAffectationProduitReseauTempo } from '@/api/affectation';
import { getAllPlanning } from '@/api/dispo';
import getDateWithAnneeSemaineAndJourDepart from '@/services/devisCommandes/getDateAnneeSemaine';
import {
  BLOQUE,
  LIBRE_OPTION,
  LIBRE_OPTION_VENDU,
  OPTION, RELANCE_OPTION,
} from '@/configuration/optionBlocage/optionBlocage';
import getDatesDepartReseauTempo from '@/services/devisCommandes/getDatesDepartReseauTempo';
import { ajoutLignesCommandeProduitReseauTempoFromPlanningReseauTempo } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauTempo';
import { get } from '@/api/produit/produitReseau';
import { TYPE_DEVIS } from '@/configuration/devisConf';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT } from '@/configuration/societe/societe';
import getProduitLocDefaut from '@/services/dcf/produit/getProduitLocDefaut';

async function getAllAffectation(produitsId, anneesSemaine) {
  const params = [];
  produitsId.forEach((produitId) => {
    params.push({
      id: produitId,
      anneeSemaines: anneesSemaine,
    });
  });
  const affectations = (await (getAffectationProduitReseauTempo(params, true))).data.result;
  return affectations;
}

function getMinAndMaxDatesWithAnneesSemaine(anneesSemaine) {
  let anneeSemaineMin = anneesSemaine[0];
  let anneeSemaineMax = anneesSemaine[0];
  anneesSemaine.forEach((anneeSemaine) => {
    if (getDateWithAnneeSemaineAndJourDepart(anneeSemaine, 0)
      .isBefore(getDateWithAnneeSemaineAndJourDepart(anneeSemaineMin, 0))) {
      anneeSemaineMin = anneeSemaine;
    } else if (getDateWithAnneeSemaineAndJourDepart(anneeSemaine, 0)
      .isAfter(getDateWithAnneeSemaineAndJourDepart(anneeSemaineMax, 0))) {
      anneeSemaineMax = anneeSemaine;
    }
  });
  return {
    dateDebut: getDateWithAnneeSemaineAndJourDepart(anneeSemaineMin, 0),
    dateFin: getDateWithAnneeSemaineAndJourDepart(anneeSemaineMax, 6),
  };
}

async function getAllDispo(produitsId, anneesSemaine) {
  const dates = getMinAndMaxDatesWithAnneesSemaine(anneesSemaine);
  const dispos = (await getAllPlanning(produitsId, dates.dateDebut, dates.dateFin)).data.result;
  return dispos;
}

function checkNiveauDispo(niveauDispoSelect, affectations, stock) {
  if (stock === 0) return false;
  if (niveauDispoSelect === LIBRE_OPTION_VENDU || affectations.length === 0) return true;
  const affectationsBloque = affectations
    .filter((affectation) => {
      return affectation.etatObtenu === BLOQUE;
    });
  const nbFacesVendu = affectationsBloque.length > 0 ? affectationsBloque
    .map((affectation) => { return affectation.nbFaces; })
    .reduce((nbFacesTotal, nbFaces) => { return nbFacesTotal + nbFaces; }) : 0;
  const affectationsOption = affectations
    .filter((affectation) => {
      return affectation.etatObtenu === OPTION || affectation.etatObtenu === RELANCE_OPTION;
    });
  const nbFacesOption = affectationsOption.length > 0 ? affectationsOption
    .map((affectation) => { return affectation.nbFaces; })
    .reduce((nbFacesTotal, nbFaces) => { return nbFacesTotal + nbFaces; }) : 0;
  if (niveauDispoSelect === LIBRE_OPTION) return (stock - nbFacesVendu > 0);
  return (stock - (nbFacesOption + nbFacesVendu) > 0);
}

function getAllInfosForLigneCommande(
  produitId, affectations, dispos, niveauDispo, anneesSemaine,
) {
  const infos = [];
  anneesSemaine.forEach((anneeSemaine) => {
    const affectationsAtAnneeSemaine = affectations.length > 0 ? affectations
      .filter((affectation) => {
        return affectation.anneSemaine === Number(anneeSemaine);
      }) : [];
    const dispoAtAnneeSemaineAndProduitId = dispos.find((dispo) => {
      return dispo.anneeSemaine === Number(anneeSemaine);
    });
    const isDispo = checkNiveauDispo(
      niveauDispo,
      affectationsAtAnneeSemaine,
      dispoAtAnneeSemaineAndProduitId ? dispoAtAnneeSemaineAndProduitId.stock : 0,
    );
    if (!isDispo) return;
    infos.push({
      ligneReseau: {
        anneeSemaine: Number(anneeSemaine),
        jourDepart: dispoAtAnneeSemaineAndProduitId.jourDepart,
        qteFacesPrevues: dispoAtAnneeSemaineAndProduitId.stock,
        qteFacesSouhaitees: dispoAtAnneeSemaineAndProduitId.stock
          - dispoAtAnneeSemaineAndProduitId.vendu,
        lignesCmdSelProduits: [],
      },
      produitId: produitId,
      affectations: affectationsAtAnneeSemaine,
      dates: getDatesDepartReseauTempo(anneeSemaine, dispoAtAnneeSemaineAndProduitId.jourDepart),
    });
  });
  return infos;
}

export default async function createLignesCommandeForRecap(
  produitsId, niveauDispo, produitLoc, anneesSemaine, allProduitsLoc, societeId,
) {
  const allAffectations = await getAllAffectation(produitsId, anneesSemaine);
  const allDispo = await getAllDispo(produitsId, anneesSemaine);
  let allInfosForCreateLignes = [];
  const promisesGetProduitsreseau = [];
  produitsId.forEach((produitId) => {
    const infosOfProduit = getAllInfosForLigneCommande(
      produitId, allAffectations[produitId], allDispo[produitId], niveauDispo, anneesSemaine,
    );
    allInfosForCreateLignes = allInfosForCreateLignes.concat(infosOfProduit);
    promisesGetProduitsreseau.push(get(produitId));
  });
  const produitsReseau = (await Promise.all(promisesGetProduitsreseau))
    .map(rslt => rslt.data.result);
  const promiseLoc = [];
  if (produitLoc === PRODUIT_ID_LOCATION_PAR_DEFAUT) {
    produitsReseau.forEach((produitReseau) => {
      promiseLoc.push(getProduitLocDefaut(
        allProduitsLoc,
        produitReseau.supportCommercial.societeId,
        produitReseau.produitReseau.produitParDefautId,
        societeId,
      ));
    });
  }
  const produitsLoc = await Promise.all(promiseLoc);
  const linkProduitLocProduitReseau = [];
  for (let i = 0; i < produitsReseau.length; i += 1) {
    linkProduitLocProduitReseau.push({
      idProduitReseau: produitsReseau[i].id,
      produitLoc: produitLoc === PRODUIT_ID_LOCATION_PAR_DEFAUT ? produitsLoc[i] : produitLoc,
    });
  }
  const lignesCommandes = [];
  const promiseLignes = [];
  allInfosForCreateLignes.forEach((info) => {
    const produit = produitsReseau.find((produitReseau) => {
      return produitReseau.id === info.produitId;
    });
    const linkFind = linkProduitLocProduitReseau.find((link) => {
      return link.idProduitReseau === info.produitId;
    });
    promiseLignes.push(ajoutLignesCommandeProduitReseauTempoFromPlanningReseauTempo(
      info.produitId,
      linkFind.produitLoc,
      info.dates,
      info.ligneReseau,
      produit, TYPE_DEVIS,
    ));
  });
  const allLignesCommandes = await Promise.all(promiseLignes);
  for (let i = 0; i < allLignesCommandes.length; i += 1) {
    const ligne = allLignesCommandes[i];
    ligne.affectation = allInfosForCreateLignes[i].affectations;
    lignesCommandes.push(ligne);
  }
  return lignesCommandes;
}
